import './PaidFeatureIcon.scss';

import React, { PureComponent } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { omit } from 'lodash';
import PropTypes from 'prop-types';

import { getFeatureMinTiers } from 'selectors/session';

import Box from 'components/Box';
import Icon from 'components/Icon';
import Tooltip from 'components/Tooltip';

import cxHelpers from 'util/className';
import { capitalizeFirstLetter } from 'util/formatter';
import { toI18n } from 'util/i18n';

@connect((state, props) => ({
  featureMinTiers: getFeatureMinTiers(state, props),
}))
@cxHelpers('PaidFeatureIcon')
export default class PaidFeatureIcon extends PureComponent {
  static propTypes = {
    feature: PropTypes.string,
    featureMinTiers: ImmutablePropTypes.map.isRequired,
    iconSize: PropTypes.string,
    noPadding: PropTypes.bool,
    tooltip: PropTypes.string,
  };

  static defaultProps = {
    iconSize: 'sm',
  };

  tier = () =>
    capitalizeFirstLetter(this.props.featureMinTiers.get(this.props.feature));

  tierTooltip = () =>
    this.props.feature &&
    toI18n('settings.pages.paid_feature_tooltip', {
      props: { tier: this.tier() },
    });

  renderIcon() {
    return (
      <Icon
        type="star"
        color="purple"
        size={this.props.iconSize}
        className={!this.props.noPadding && 'paxxs'}
      />
    );
  }
  render() {
    const boxProps = omit(
      this.props,
      'featureMinTiers',
      'dispatch',
      'iconSize',
      'noPadding'
    );

    return (
      <Tooltip
        arrow
        placement="top"
        title={this.props.tooltip || this.tierTooltip() || ''}
      >
        <Box {...boxProps} bradius={5} inlineBlock className={this.cx()}>
          {this.renderIcon()}
        </Box>
      </Tooltip>
    );
  }
}
